import React from 'react';
import { YourInfo } from '../YourInfo/YourInfo';
import { Separator } from '../../../../CommonComponents/OPL/Separator/Separator';
import { PartnerInfo } from '../PartnerInfo/PartnerInfo';
import { Dependents } from '../Dependents/Dependents';
import { EstatePlanningDTO } from '../../api/useEstatePlanningPersonalInfoQuery';
import { PersonalInfoDTO } from '../../api/usePersonalInfoQuery';
import { TrustsDTO } from '../../api/useTrustsQuery';

interface Props {
  data: {
    EstatePlanning?: EstatePlanningDTO;
    PersonalInfo: PersonalInfoDTO;
    Trusts?: TrustsDTO;
  };
  showPartnerSection: boolean;
  setShowPartnerSection(showPartnerSection: boolean): void;
  onAddPartner(): void;
  onDeletePartner(): void;
  isEstatePlanning?: boolean;
}

export const PersonalInfoForm = ({
  data,
  showPartnerSection,
  setShowPartnerSection,
  onAddPartner,
  onDeletePartner,
  isEstatePlanning,
}: Props) => {
  return (
    <>
      <YourInfo
        data={data.PersonalInfo}
        isEstatePlanning={!!isEstatePlanning}
        setShowPartnerSection={setShowPartnerSection}
      />

      <Separator my="32" />

      <PartnerInfo
        data={data.PersonalInfo}
        showPartnerSection={showPartnerSection}
        onAddPartner={onAddPartner}
        onDeletePartner={onDeletePartner}
        isEstatePlanning={!!isEstatePlanning}
      />

      <Separator my="32" />

      <Dependents />
    </>
  );
};
